import styled from '@emotion/styled';
import { Div } from '../../layouts';

export const FlightsManagerDesktopEl = styled(Div)`
    & {
        position: relative;
    }

    & .FlightsManagerFooter {
        display: flex;
    }

    & .FlightsManagerFooterLeft {
        flex-basis: 100%;
        display: flex;
        flex-direction: column;
    }

    & .FlightsManagerAddFlight {
        flex-basis: 100%;
    }

    & .FlightsManagerFooterCTA,
    & .FlightsManagerFooterCTA > * {
        white-space: nowrap;
        display: inline-block;
    }
`;
